import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RegisterComponent } from "./register/register.component";
import { EmailConfirmationComponent } from "./email-confirmation/email-confirmation.component";
import { LoginComponent } from "./login/login.component";
import { ControlsModule } from "src/app/controls/controls.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { TablerIconComponent } from "angular-tabler-icons";

@NgModule({
  declarations: [
    RegisterComponent,
    EmailConfirmationComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    ControlsModule,
    ReactiveFormsModule,
    TablerIconComponent
  ],
  exports: [
    RegisterComponent,
    EmailConfirmationComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ]
})
export class AuthModule { }